import React from "react";

import { LoadingIcon as Loading } from "@packages/ds";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";

import OrderItem from "../OrderItem/OrderItem";

import { Layout, Title } from "./OrderItemList.styles";

const OrderItemList = props => {
  const { orders, title } = props;

  const orderFilter = order => {
    const title = order.id;

    if (!title || !props.titleFilter) {
      return true;
    }

    return title.includes(props.titleFilter);
  };

  return (
    <Layout>
      <Title tag="h4">{title}</Title>

      {props.isLoading ? (
        <Loading />
      ) : (
        orders &&
        orders
          .sort((a, b) => {
            if (a.billing_period_end < b.billing_period_end) return 1;
            if (a.billing_period_end > b.billing_period_end) return -1;
            return 0;
          })
          .filter(orderFilter)
          .map(order => <OrderItem order={order} key={order.id} />)
      )}
    </Layout>
  );
};

OrderItemList.propTypes = {
  orders: PropTypes.object,
  orderDetails: PropTypes.object,
  expandedItem: PropTypes.string,
  title: PropTypes.string,
  loadOrder: PropTypes.func,
  expand: PropTypes.func,
  intl: PropTypes.object,
  titleFilter: PropTypes.string,
  isLoading: PropTypes.bool,
  organizationId: PropTypes.string
};

export default injectIntl(OrderItemList);
